import { spAddress_State_List } from '@models/StoredProcs/spAddress_State_List';

export class spAddress_State_ListX extends spAddress_State_List {
    public constructor(init?: Partial<spAddress_State_ListX>) {
        super();
        Object.assign(this, init);
    }

    get state_display(): string {
        return `${this.state_code}-${this.state_name}`;
    }
}
